import React, { PureComponent } from 'react';

import cls from 'classnames';

import styles from './index.module.scss';

interface IProps {
  className?: string;
}

export class BetaTag extends PureComponent<IProps> {
  render(): React.ReactNode {
    const { className } = this.props;
    return <sup className={cls(styles.betaTag, className)}>BETA</sup>;
  }
}